import type { State } from '../types.tsx';

export const getProductUsageStartTimestamp = (state: State) => state.productUsageStartTimestamp;
